// FAQ Data is now loaded from faq-data.js

// Add Fuse.js CDN
document.addEventListener('DOMContentLoaded', () => {
    const fuseScript = document.createElement('script');
    fuseScript.src = 'https://cdn.jsdelivr.net/npm/fuse.js@6.6.2';
    fuseScript.integrity = 'sha384-zPE55eyESN+FxCWGEnlNxGyAPJud6IZ6TtJmXb56OFRGhxZPN4akj9rjA3gw5Qqa';
    fuseScript.crossOrigin = 'anonymous';
    fuseScript.onload = () => {
        console.log('🤖 Anime Store FAQ Chatbot: Fuse.js loaded');
        initializeChatbot();
    };
    document.head.appendChild(fuseScript);
});

function initializeChatbot() {
    // Create HTML structure if it doesn't exist
    let container = document.getElementById('chatbot-container');
    if (!container) {
        console.log('🤖 Anime Store FAQ Chatbot: No container found, creating one');
        container = document.createElement('div');
        container.id = 'chatbot-container';
        document.body.appendChild(container);
    }

    // Create chatbot structure
    container.innerHTML = `
        <button id="chatbot-toggle" class="chatbot-toggle">
            <span class="open-text">💬</span>
            <span class="close-text">✕</span>
        </button>
        <div id="chatbot" style="display: none">
            <div class="chatbot-header">
                <h3>アニメストアFAQ</h3>
                <button id="mobile-close-button" class="mobile-close-button">✕</button>
                <button id="restart-button" class="restart-button" style="display: none;">リセット</button>
            </div>
            <div id="chat-messages"></div>
            <div id="chat-options"></div>
            <div class="chat-input-container">
                <input type="text" id="chat-input" placeholder="キーワードで質問を検索…" />
            </div>
        </div>
        <template id="message-template">
            <div class="message">
                <div class="message-content"></div>
            </div>
        </template>
        <template id="options-template">
            <button class="option"></button>
        </template>
    `;

    // Initialize chatbot
    console.log('🤖 Anime Store FAQ Chatbot: Initializing chatbot interface');
    const chatbot = new ChatBot();
    
    const msgs = document.getElementById('chat-messages');
    msgs.addEventListener('wheel', e => e.stopPropagation(), { passive: false });
    

    // Setup toggle button functionality
    const toggleButton = document.getElementById('chatbot-toggle');
    const chatbotElement = document.getElementById('chatbot');
    const mobileCloseButton = document.getElementById('mobile-close-button');
    
    toggleButton.addEventListener('click', () => {
        const isVisible = chatbotElement.style.display !== 'none';
        const isMobile = window.innerWidth <= 768;
        
        if (isMobile) {
            // On mobile, toggle button only opens the chat
            if (!isVisible) {
                chatbotElement.style.display = 'flex';
                // Hide the toggle button on mobile when chat opens
                toggleButton.classList.add('mobile-hidden');
                // Prevent body scrolling when chat is open on mobile
                document.body.style.overflow = 'hidden';
                // If opening the chatbot and no messages yet, show welcome message
                if (chatbot.messagesContainer.children.length === 0) {
                    chatbot.showWelcomeMessage();
                }
            }
            // Don't close on mobile - only the mobile close button can close it
        } else {
            // Desktop behavior: normal toggle
            chatbotElement.style.display = isVisible ? 'none' : 'flex';
            toggleButton.classList.toggle('active', !isVisible);
            
            // If opening the chatbot and no messages yet, show welcome message
            if (!isVisible && chatbot.messagesContainer.children.length === 0) {
                chatbot.showWelcomeMessage();
            }
        }
    });
    
    // Mobile close button functionality
    mobileCloseButton.addEventListener('click', () => {
        chatbotElement.style.display = 'none';
        // Show the toggle button again and reset its state
        toggleButton.classList.remove('active');
        toggleButton.classList.remove('mobile-hidden');
        // Restore body scrolling when chat is closed on mobile
        document.body.style.overflow = '';
    });
    
    // Handle viewport changes for body scroll management
    function handleViewportChange() {
        const isMobile = window.innerWidth <= 768;
        const isChatVisible = chatbotElement.style.display !== 'none';
        
        // If switching from mobile to desktop and chat is open, restore scroll
        if (!isMobile && isChatVisible) {
            document.body.style.overflow = '';
        }
        // If switching from desktop to mobile and chat is open, prevent scroll
        else if (isMobile && isChatVisible) {
            document.body.style.overflow = 'hidden';
        }
    }
    
    // Listen for viewport changes (CSS handles the toggle button positioning automatically)
    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', handleViewportChange);
    }
    
    // Fallback to window resize for broader compatibility
    window.addEventListener('resize', handleViewportChange);
}

class ChatBot {
    constructor() {
        this.messagesContainer = document.getElementById('chat-messages');
        this.optionsContainer = document.getElementById('chat-options');
        this.restartButton = document.getElementById('restart-button');
        this.messageTemplate = document.getElementById('message-template');
        this.optionsTemplate = document.getElementById('options-template');
        this.chatInput = document.getElementById('chat-input');
        this.currentPath = [];
        this.lastEntryMethod = 'navigation'; // Track entry method
        this.lastSearchQuery = ''; // Track last search query
        this.setupFuse();
        this.init();
        this.setupRestartButton();
        this.setupChatInput();
    }

    setupFuse() {
        // Flatten the tree for search with path information
        const searchData = this.flattenTreeForSearch(faqData.nodes);
        
        // Initialize Fuse with enhanced options for Japanese search
        this.fuse = new Fuse(searchData, {
            keys: [
                'question',
                'answer', 
                'processedQuestion',
                'processedAnswer',
                'keywords',
                'synonyms',
                'path'
            ],
            threshold: 0.5, // Slightly more lenient for Japanese
            includeScore: true,
            minMatchCharLength: 2
        });
    }

    // Flatten tree for search with path information
    flattenTreeForSearch(nodes, parentPath = '') {
        const searchData = [];
        
        nodes.forEach(node => {
            const currentPath = parentPath ? `${parentPath} > ${node.title || node.question}` : (node.title || node.question);
            
            if (node.children) {
                // This is a category node
                searchData.push({
                    id: node.id,
                    title: node.title,
                    path: currentPath,
                    type: 'category',
                    processedTitle: this.processJapaneseText(node.title)
                });
                
                // Recursively process children
                searchData.push(...this.flattenTreeForSearch(node.children, currentPath));
            } else {
                // This is a leaf node (FAQ item)
                const processedQuestion = this.processJapaneseText(node.question);
                const processedAnswer = this.processJapaneseText(node.answer);
                
                searchData.push({
                    id: node.id,
                    question: node.question,
                    answer: node.answer,
                    category: parentPath.split(' > ')[0] || node.title,
                    path: currentPath,
                    type: 'faq',
                    processedQuestion: processedQuestion,
                    processedAnswer: processedAnswer,
                    keywords: node.keywords || '',
                    synonyms: node.synonyms || ''
                });
            }
        });
        
        return searchData;
    }

    // Recursive function to show nodes
    showNodes(nodes, title = null) {
        const options = nodes.map(node => ({
            id: node.id,
            text: node.title || node.question,
            question: node.question,
            answer: node.answer,
            children: node.children
        }));
        
        if (title) {
            // When title is provided, render title + options in a single bubble
            this.addMessage(title, false, options);
        } else {
            // When no title, just show the generic prompt with options
            this.addMessage('以下からお選びください：', false, options);
        }
    }

    // Generic handleOptionClick for recursive navigation
    handleOptionClick(node) {
        console.log('handleOptionClick called with:', node);
        
        // Track entry method as navigation
        this.lastEntryMethod = 'navigation';
        
        // Add user's selection as a message
        this.addMessage(node.text || node.question, true);
        
        // Add a small delay before showing the response
        setTimeout(() => {
            if (node.children) {
                // This is a category node - show its children
                this.showNodes(node.children);
            } else {
                // This is a leaf node - show the answer and feedback
                this.addMessage(node.answer, false);
                setTimeout(() => {
                    const feedbackOptions = [
                        {
                            text: '✅ 解決した',
                            value: 'resolved',
                            class: 'success',
                            isFeedback: true
                        },
                        {
                            text: '❌ 解決しなかった',
                            value: 'unresolved',
                            class: 'error',
                            isFeedback: true
                        }
                    ];
                    console.log('Adding feedback options. Current path:', this.currentPath);
                    // Don't scroll for the feedback message
                    this.addMessage('この回答は問題を解決しましたか？', false, feedbackOptions, false);
                }, 500);
                this.restartButton.style.display = 'inline-block';
            }
        }, 500);

        this.currentPath.push(node);
    }

    setupChatInput() {
        this.chatInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                const query = this.chatInput.value.trim();
                if (query) {
                    this.handleSearch(query);
                    this.chatInput.value = '';
                }
            }
        });
    }

    handleSearch(query) {
        // Track search query and entry method
        this.lastSearchQuery = query;
        this.lastEntryMethod = 'search';
        
        // Add user's query as a message
        this.addMessage(query, true);

        // Process the query for Japanese search
        const processedQuery = this.processJapaneseText(query);
        
        // Search with both original and processed query
        const originalResults = this.fuse.search(query);
        const processedResults = this.fuse.search(processedQuery);
        
        // Combine and deduplicate results
        const allResults = [...originalResults, ...processedResults];
        const uniqueResults = this.deduplicateResults(allResults);

        if (uniqueResults.length > 0) {
            // Filter results with reasonable scores and limit to top 5
            const goodResults = uniqueResults
                .filter(result => result.score < 0.7) // More lenient threshold for Japanese
                .slice(0, 5)
                .map(result => {
                    // Always show only the last two elements of the path (parent and leaf)
                    let displayText = '';
                    if (result.item.path) {
                        const parts = result.item.path.split(' > ');
                        if (parts.length >= 2) {
                            displayText = parts.slice(-2).join(' > ');
                        } else {
                            displayText = parts[0];
                        }
                    } else if (result.item.category && result.item.question) {
                        displayText = `${result.item.category} > ${result.item.question}`;
                    } else {
                        displayText = result.item.question || '';
                    }
                    return {
                        id: result.item.id,
                        text: displayText,
                        answer: result.item.answer,
                        nodeId: result.item.id,
                        type: result.item.type
                    };
                });

            if (goodResults.length > 0) {
                this.addMessage('以下の質問が見つかりました：', false, goodResults);
            } else {
                this.showNoResults(query);
            }
        } else {
            this.showNoResults(query);
        }

        // Show restart button
        this.restartButton.style.display = 'block';
        
        // Scroll to bottom
        this.scrollToBottom();
    }

    // Deduplicate search results
    deduplicateResults(results) {
        const seen = new Set();
        return results.filter(result => {
            const key = result.item.id;
            if (seen.has(key)) {
                return false;
            }
            seen.add(key);
            return true;
        });
    }

    showNoResults(query) {
        this.addMessage(`「${query}」に関連する質問は見つかりませんでした。\n\n以下のカテゴリーから選択してください：`, false, this.getMainCategories());
    }

    init() {
        // Show the header that was hidden initially
        const header = document.querySelector('.chatbot-header');
        if (header) {
            header.style.display = 'block';
        }
        this.showWelcomeMessage();
    }

    showWelcomeMessage() {
        this.showNodes(faqData.nodes, 'アニメストアFAQへようこそ。以下のカテゴリーからお選びください。');
    }

    getMainCategories() {
        return faqData.nodes.map(node => ({
            id: node.id,
            text: node.title
        }));
    }

    setupRestartButton() {
        this.restartButton.addEventListener('click', () => {
            this.currentPath = [];
            this.clearChat();
            this.showWelcomeMessage();
            this.restartButton.style.display = 'none';
        });
    }

    clearChat() {
        this.messagesContainer.innerHTML = '';
        this.chatInput.value = '';
    }

    createFeedbackButtons() {
        return [
            {
                text: '✅ 解決した',
                value: 'resolved',
                class: 'success',
                isFeedback: true
            },
            {
                text: '❌ 解決しなかった',
                value: 'unresolved',
                class: 'error',
                isFeedback: true
            }
        ];
    }

    addMessage(text, isUser = false, options = null, shouldScroll = true) {
        const messageNode = this.messageTemplate.content.cloneNode(true);
        const messageDiv = messageNode.querySelector('.message');
        const messageContent = messageNode.querySelector('.message-content');
        
        if (isUser) {
            messageDiv.classList.add('user');
        }
        
        // Check if text contains HTML links
        if (text.includes('<a href=')) {
            messageContent.innerHTML = text;
        } else {
            messageContent.textContent = text;
        }

        if (options) {
            const optionsGroup = document.createElement('div');
            optionsGroup.className = 'options-group';
            
            options.forEach(option => {
                const button = document.createElement('button');
                button.className = option.class ? `option-button ${option.class}` : 'option-button';
                button.textContent = option.text || option.question;
                
                if (option.isFeedback) {
                    button.onclick = () => {
                        // Disable all feedback buttons in this group
                        optionsGroup.querySelectorAll('button').forEach(btn => {
                            btn.disabled = true;
                            btn.classList.add('disabled');
                        });
                        console.log('Feedback button clicked:', option.value);
                        this.handleFeedback(option.value);
                    };
                } else {
                    button.onclick = () => {
                        // Disable all option buttons in this group
                        optionsGroup.querySelectorAll('button').forEach(btn => {
                            btn.disabled = true;
                            btn.classList.add('disabled');
                        });
                        console.log('Option button clicked:', option);
                        
                        // Check if this is a search result that needs teleportation
                        if (option.nodeId && option.type === 'faq') {
                            // Teleport to the specific FAQ item
                            this.navigateToNode(option.nodeId);
                        } else {
                            // Regular navigation
                            this.handleOptionClick(option);
                        }
                    };
                }
                
                optionsGroup.appendChild(button);
            });
            
            messageContent.appendChild(optionsGroup);
        }

        this.messagesContainer.appendChild(messageNode);
        
        // Only scroll if shouldScroll is true
        if (shouldScroll) {
            this.scrollToMessage();
        }

        // Disable all previous option groups when adding new options
        if (options) {
            const allOptionGroups = this.messagesContainer.querySelectorAll('.options-group');
            const previousGroups = Array.from(allOptionGroups).slice(0, -1); // All except the last (current) group
            previousGroups.forEach(group => {
                group.querySelectorAll('button').forEach(button => {
                    button.disabled = true;
                    button.classList.add('disabled');
                });
            });
        }
    }

    async handleFeedback(feedback) {
        console.log('handleFeedback called with:', feedback);
        const feedbackText = feedback === 'resolved' ? '✅ 解決した' : '❌ 解決しなかった';
        
        // Add user's feedback as a message
        this.addMessage(feedbackText, true);

        // Build and log the complete conversation path
        const path = this.buildPath();
        path.feedback = feedbackText;
        
        console.log('Complete conversation path:', path);
        // Log feedback asynchronously—don’t block the UI
        this.logFeedback(path).catch(err => console.error(err));

        // Add a small delay before showing the response
        await new Promise(resolve => setTimeout(resolve, 500));
        
        // Show appropriate response based on feedback
        if (feedback === 'resolved') {
            this.addMessage('解決できて良かったです！他にご質問はありますか？', false);
            this.showNodes(faqData.nodes);
        } else {
            this.addMessage('申し訳ありません。もう一度サポートさせてください。どのご質問でしょうか？', false);
            this.showNodes(faqData.nodes);
        }
    }

    buildPath() {
        // Create the path object with the full conversation history
        const path = {
            timestamp: new Date(new Date().getTime() + (9 * 60 * 60 * 1000)).toISOString(), // Convert to JST
            entryMethod: this.lastEntryMethod || 'navigation', // Track how user entered
            searchQuery: this.lastSearchQuery || '', // Track last search query
            q1_category: null,
            q2_topic: null,
            q3_subtopic: null,
            q4_question: null,
            feedback: null
        };

        // Map the conversation path to the appropriate fields
        this.currentPath.forEach((item, index) => {
            if (index === 0) {
                path.q1_category = item.title || item.text;
            } else {
                // For questions, store the actual question text
                const questionText = item.question || item.text;
                if (!path.q2_topic) {
                    path.q2_topic = questionText;
                } else if (!path.q3_subtopic) {
                    path.q3_subtopic = questionText;
                } else if (!path.q4_question) {
                    path.q4_question = questionText;
                }
            }
        });

        return path;
    }

    async logFeedback(path) {
        console.log('Attempting to log feedback to Google Sheets:', path);
        
        try {
            // Format data exactly as specified for new column structure
            const data = {
                entryMethod: path.entryMethod || '',
                searchQuery: path.searchQuery || '',
                q1: path.q1_category || '',
                q2: path.q2_topic || '',
                q3: path.q3_subtopic || '',
                q4: path.q4_question || '',
                feedback: path.feedback || ''
            };

            console.log('Sending data to Google Sheets:', data);

            // Convert data to form-encoded format
            const formData = new URLSearchParams();
            Object.keys(data).forEach(key => {
                formData.append(key, data[key]);
            });

            const response = await fetch('https://script.google.com/macros/s/AKfycbyLF1FXY7FV4stjolQ8Yglb1qF1xERc2TWVQZOLQ4MvAtZtkcGYS27aZdrgKeyr6aPj/exec', {
                method: 'POST',
                mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: formData.toString()
            });

            console.log('Feedback logged successfully');
            
        } catch (error) {
            console.error('Error logging to Google Sheets:', error);
        }
    }

    scrollToMessage() {
        setTimeout(() => {
            // Get all message elements
            const messages = this.messagesContainer.children;
            if (messages.length > 0) {
                // Find the last user message to scroll to
                let targetMessage = null;
                for (let i = messages.length - 1; i >= 0; i--) {
                    const message = messages[i];
                    if (message.classList.contains('user')) {
                        targetMessage = message;
                        break;
                    }
                }
                
                // If no user message found, use the last message
                if (!targetMessage) {
                    targetMessage = messages[messages.length - 1];
                }
                
                // Calculate the scroll position to show the user message
                // Account for the header height (50px) plus some padding
                const headerHeight = 50;
                const scrollPosition = targetMessage.offsetTop - headerHeight - 10;
                
                // Ensure we don't scroll past the top
                const maxScroll = this.messagesContainer.scrollHeight - this.messagesContainer.clientHeight;
                const finalScrollPosition = Math.min(scrollPosition, maxScroll);
                
                // Smooth scroll to the calculated position
                this.messagesContainer.scrollTo({
                    top: Math.max(0, finalScrollPosition),
                    behavior: 'smooth'
                });
            }
        }, 50);
    }

    scrollToBottom() {
        setTimeout(() => {
            // Get all message elements
            const messages = this.messagesContainer.children;
            if (messages.length > 0) {
                // Find the last message to scroll to
                const targetMessage = messages[messages.length - 1];
                
                // Calculate the scroll position to show the last message
                // Account for the header height (50px) plus some padding
                const headerHeight = 50;
                const scrollPosition = targetMessage.offsetTop - headerHeight - 10;
                
                // Smooth scroll to the calculated position
                this.messagesContainer.scrollTo({
                    top: scrollPosition,
                    behavior: 'smooth'
                });
            }
        }, 50);
    }

    // Japanese text processing function
    processJapaneseText(text) {
        if (!text) return '';
        
        let processed = text;
        
        // Convert katakana to hiragana
        processed = this.katakanaToHiragana(processed);
        
        // Remove Japanese particles
        processed = this.removeJapaneseParticles(processed);
        
        // Handle negatives (届かない → 届く)
        processed = this.handleJapaneseNegatives(processed);
        
        return processed;
    }

    // Convert katakana to hiragana
    katakanaToHiragana(text) {
        return text.replace(/[\u30A1-\u30F6]/g, function(match) {
            return String.fromCharCode(match.charCodeAt(0) - 0x60);
        });
    }

    // Remove Japanese particles
    removeJapaneseParticles(text) {
        const particles = ['が', 'を', 'に', 'で', 'へ', 'と', 'など', 'の', 'は', 'も', 'や', 'か', 'から', 'まで'];
        let processed = text;
        particles.forEach(particle => {
            processed = processed.replace(new RegExp(particle, 'g'), ' ');
        });
        return processed.replace(/\s+/g, ' ').trim();
    }

    // Handle Japanese negatives
    handleJapaneseNegatives(text) {
        const negativePatterns = [
            { pattern: /(.)ない/g, replacement: '$1' },
            { pattern: /(.)ません/g, replacement: '$1' },
            { pattern: /(.)ぬ/g, replacement: '$1' },
            { pattern: /(.)ん/g, replacement: '$1' }
        ];
        
        let processed = text;
        negativePatterns.forEach(({ pattern, replacement }) => {
            processed = processed.replace(pattern, replacement);
        });
        
        return processed;
    }

    // Find node by ID in the tree
    findNodeById(nodes, id) {
        for (const node of nodes) {
            if (node.id === id) {
                return node;
            }
            if (node.children) {
                const found = this.findNodeById(node.children, id);
                if (found) return found;
            }
        }
        return null;
    }

    // Navigate to a specific node by simulating clicks
    navigateToNode(nodeId) {
        const node = this.findNodeById(faqData.nodes, nodeId);
        if (node) {
            this.handleOptionClick(node);
        }
    }
} 